
<div class="modal-header align-items-center">
  <div class="col">
    <h4 class="modal-title">
      <span translate>Command result</span>
    </h4>
  </div>
  <div class="col-auto">
    <button (click)="onClose()" aria-label="Close" class="close" type="button">
      <span aria-hidden="true" class="fa-solid fa-xmark"></span>
    </button>
  </div>
</div>
<div class="modal-body">
  <b translate>Status code:</b>
  <p>{{status}}</p>
  <b translate>Payload:</b>
  <p>{{payload}}</p>
</div>
<div class="modal-footer">
  <div class="modal-footer-inner">
    <div class="row align-items-center flex-fill">
      <div class="col"></div>
      <div class="col-auto">
        <button (click)="onClose()"
                class="btn btn-primary"
                translate type="button">Close
        </button>
      </div>
    </div>
  </div>
</div>
